
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offer",
      function () {
        return require("private-next-pages/offer/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offer"])
      });
    }
  